import { render, staticRenderFns } from "./KeywordDetailsModal.vue?vue&type=template&id=1b665ca0&scoped=true"
import script from "./KeywordDetailsModal.vue?vue&type=script&lang=js"
export * from "./KeywordDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./KeywordDetailsModal.vue?vue&type=style&index=0&id=1b665ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b665ca0",
  null
  
)

export default component.exports